import React from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const checkBoxStyle = {
  ".MuiFormControlLabel-label": {
    fontSize: "1.4rem !important",
    fontFamily: "'Inter-Medium'",
    textTransform: 'capitalize',
  },
};
function CustomCheckBox({ value, optionList, onChangeValue, helperText="" }) {
  return (
    <FormGroup>
      {
        optionList.map((option,index) => (
          <FormControlLabel 
            control={<Checkbox
              tabIndex="0" 
              sx={{
                '&.Mui-checked': {
                  color: "#7F56D9",
                },
              }}
              checked={value.some((s)=>s===option)} 
              onChange={(e)=>{onChangeValue(option)}}/>} 
            label={option} 
            sx={[checkBoxStyle]}
          />
        ))
      }
      <p style={{color: "red", fontSize: "1.4rem"}}>{helperText}</p>
    </FormGroup>
  );
}

export default CustomCheckBox;
